/* Icon registry for CIcon (Vue 2 CoreUI read it from `$root.$options.icons`). */
let registry = {}
export function setIcons (icons) { registry = Object.assign({}, registry, icons || {}) }
export function getIcon (name) { return registry[name] }
